import AbsorbLogic from './absorb-logic';
import { IAbsorbElement, IAbsorbManager } from '@src/slide/application/service/absorb-manager/absorb-manager.interface';

/**
 * 公共吸附管理
 */
export default class AbsorbManager implements IAbsorbManager {
    /**
     * 网格线吸附
     */
    public gridAbsorbLogic: AbsorbLogic;
    /**
     * 参考线吸附
     */
    public guidesAbsorbLogic?: AbsorbLogic;
    private isGridAbsorb = false;

    constructor() {
        this.gridAbsorbLogic = new AbsorbLogic({
            isAbsorbEndPoint: false,
        });
    }

    /**
     * 开启/关闭网格线吸附
     * @param enable
     */
    public setIsGridAbsorb(enable: boolean) {
        this.isGridAbsorb = enable;
    }

    /**
     * 响应网格线吸附
     * @param props
     */
    public handleGridAbsorbElement(props: IAbsorbElement): void {
        const { model } = props;
        if (model?.props?.style?.rotate || !this.isGridAbsorb || model?.props?.locks?.noChangeAspect === 1) return;
        this.gridAbsorbLogic?.handleAbsorbElement(props);
    }
}
